export default function RingProgress({ value, size = 72, label }: { value: number; size?: number; label: string }) {
  const v = Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 0;
  const c = 2 * Math.PI * 28;
  return (
    <svg width={size} height={size} viewBox="0 0 72 72" role="img" aria-label={`${label}: ${Math.round(v)}%`}>
      <circle cx={36} cy={36} r={28} fill="none" className="stroke-track dark:stroke-line" strokeWidth={9} />
      <circle cx={36} cy={36} r={28} fill="none" className="stroke-slate-ink" strokeWidth={9} strokeLinecap="round"
        strokeDasharray={`${(c * v) / 100} ${c}`} transform="rotate(-90 36 36)" />
    </svg>
  );
}
